<template>
    <div id="custom_menu"
         :class="[menuDrawable ? 'menu_drawable' : '', isMobile ? 'mobile' : '']">
        <svg v-if="isMobile" id="button_toggle_menu" :class="{'stroke-white active': toggleMenu}"
             class="ham ham_rotate ham_8" viewBox="0 0 100 100" width="80" @click="toggleMenu = !toggleMenu">
            <path :class="{'white': this.$route.params.experienceToken}" class="ham_line top"
                  d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
            <path :class="{'white': this.$route.params.experienceToken}" class="ham_line middle" d="m 30,50 h 40" />
            <path :class="{'white': this.$route.params.experienceToken}" class="ham_line bottom"
                  d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
        </svg>
        <transition name="slide-fade">
            <div v-if="!isMobile || toggleMenu" id="menu_nav_bar" :class="{'active': isMobile}">
                <div id="logo_container">
                    <img id="logo_blinkl" :class="{'active': isMobile}"
                         src="../../public/img/BLINKL-LOGO-WHITE.svg" alt="">
                </div>
                <v-container id="menu_button_container" fluid>
                    <v-layout row wrap>
                        <v-flex v-for="item in menuItems" :key="item.title" xs12 class="menu_item">
                            <v-btn class="custom_btn_menu_color" :to="item.link" @click="toggleMenu = false">
                                <i v-if="!isMobile" :class="'fa-' + item.icon" class="menu_icon fas" />
                                <p v-if="menuDrawable || isMobile" class="menu_title">
                                    {{ item.title }}
                                </p>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap class="layout_bottom">
                        <v-flex xs12 class="menu_item align-self-end">
                            <v-btn class="custom_btn_menu_color" href="./logout">
                                <i v-if="!isMobile" class="menu_icon fas fa-power-off" />
                                <p v-if="menuDrawable || isMobile" class="menu_title">
                                    Déconnexion
                                </p>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AppMenu',
        data () {
            return {
                menuItems: [
                    { icon: 'images', title: 'Expériences', link: '/experiences' },
                    { icon: 'user-alt', title: 'Compte', link: '/account' },
                    { icon: 'envelope', title: 'Contact', link: '/contact' },
                    { icon: 'ambulance', title: 'FAQ', link: '/support' }
                ]
            };
        },
        computed: {
            ...mapGetters('app', ['isMobile', 'windowSize']),
            menuDrawable: {
                get () {
                    return this.$store.state.app.menuDrawable;
                }
            },
            toggleMenu: {
                get () {
                    return this.$store.state.app.toggleMenu;
                },
                set (toggleMenu) {
                    return this.$store.commit('app/SET_TOGGLE_MENU', { toggleMenu });
                }
            }
        },
        watch: {
            windowSize: function (val) {
                this.toggleMenu = val <= 220 ? this.toggleMenu : false;
            }
        },
        mounted () {
            this.toggleMenu = this.windowSize <= 220 ? this.toggleMenu : false;
        }
    };
</script>

<style lang="scss" scoped>

    #custom_menu {
        z-index: 20;
        width: 75px;
        background-color: #393E46;
        height: 100% !important;
        transition: all 0.3s ease-out;
    }

    #custom_menu.menu_drawable {
        width: 220px;
        transition: all 0.3s ease-out;
    }

    #custom_menu.mobile {
        height: 0 !important;
        width: 100% !important;
        transition: all 0.3s ease-out;
    }

    #custom_menu.mobile.active {
        height: 100% !important;
        width: 100% !important;
        transition: all 0.3s ease-out;
    }

    #custom_menu p {
        font-size: 16px;
    }

    #button_toggle_menu {
        z-index: 21;
        top: 22px;
        height: 30px;
        width: 30px;
        right: 17px;
        position: absolute;
        transition: top 0.5s ease-in;
    }

    #button_toggle_menu.active {
        top: 22px !important;
        transition: top 0.1s ease-in;
    }

    #menu_nav_bar {
        height: 100vh !important;
        background-color: #393E46;
        z-index: 20;
        box-shadow: unset;
    }

    #logo_container {
        position: relative;
        height: 80px !important;
        width: 100% !important;
    }

    #menu_nav_bar.active {
        position: fixed !important;
        width: 100%;
        height: 100% !important;
    }

    .menu_overlay_toggle {
        transform: scale(200);
    }

    #menu_button_container {
        position: relative;
        z-index: 11;
        text-align: center;
        overflow: hidden;
        left: 0;
        width: 100%;
        background-color: #393E46;
        height: calc(100% - 80px);
        padding: 25px 0 0;
    }

    #menu_button_container .layout_bottom {
        position: absolute;
        bottom: 50px;
        width: 100%;
    }

    #menu_button_container * * {
        margin: 0;
    }

    #logo_blinkl.active {
        max-height: 5vh;
    }

    #logo_blinkl {
        z-index: 20;
        position: absolute;
        padding-left: 15px;
        padding-right: 15px;
        left: 50%;
        top: 50%;
        max-width: 80%;
        min-width: 80px;
        transform: translate(-50%, -50%)
    }

    .slide-fade-enter-active {
        transition: all .4s ease !important;
    }

    .slide-fade-leave-active {
        transition: all .6s ease !important;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateY(-150%) !important;
        opacity: 0;
    }

    .menu_item {
        color: #FFF;
        font-size: 18px;
        line-height: 40px;
        height: 70px;
    }

    .menu_icon {
        font-size: 20px;
    }

    .menu_item > * {
        min-width: 0;
        height: 95% !important;
    }

    .menu_title {
        text-align: center;
        margin-left: 15px !important;
    }

    .custom_btn_menu_color {
        background-color: #393E46 !important;
    }

    //** SVG ANIMATION + STYLE **//

    .ham_8 .top {
        stroke-dasharray: 40 160;
    }

    .ham_8 .middle {
        stroke-dasharray: 40 142;
        transform-origin: 50%;
        transition: transform 400ms;
    }

    .ham_8 .bottom {
        stroke-dasharray: 40 85;
        transform-origin: 50%;
        transition: transform 400ms, stroke-dashoffset 400ms;
    }

    .ham_8.active .top {
        stroke-dashoffset: -64px;
    }

    .ham_8.active .middle {
        //stroke-dashoffset: -20px;
        transform: rotate(90deg);
    }

    .ham_8.active .bottom {
        stroke-dashoffset: -64px;
    }

    .ham {
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        transition: transform 400ms;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        transform: scale(2);

    }

    .ham_rotate.active {
        transform: scale(2) rotate(45deg);
    }

    .ham_line {
        fill: none;
        transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
        stroke: #393E46;
        stroke-width: 5.5;
        stroke-linecap: round;
    }

    .active * {
        stroke: #FFF;
    }

    .white {
        stroke: #FFF !important;
    }

    //** VUETIFY CORRECTIF **//
    .row {
        margin: 0 !important;
    }

    .flex {
        padding: 0 !important;
    }

    .v-btn {
        background-color: transparent;
        width: 100%;
        text-transform: unset;
    }

    .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
        background-color: #393E46;
        color: #FFF;
    }

    .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
        background-color: #169CEB;
        opacity: 1;
    }
</style>
